<template>
    <div class="rental-status">
        <template v-if="rentalStatus === 'FULLY_APPROVED'">
            <b-icon-check2-all variant="success"/>
            <i class="ml-1 text-success">Fully Approved</i>
        </template>
        <template v-if="rentalStatus === 'APPROVED_FOR_PROJECT'">
            <b-icon-check2 variant="primary"/>
            <i class="ml-1 text-info">Approved for Project</i>
        </template>
        <template v-if="rentalStatus === 'UNAPPROVED'">
            <b-icon-x-circle variant="danger"/>
            <i class="ml-1 text-danger">Pending Approval</i>
        </template>
    </div>
</template>

<script>
export default {
    name: 'RentalStatus',
    props: {
        rental: Object, //Can pass either full rental object or status
        status: String
    },
    computed: {
        rentalStatus () {
            if (this.rental) {
                return this.rental.status
            }
            return this.status
        }
    }
}
</script>

<style scoped>

</style>